const faNums = '۰۱۲۳۴۵۶۷۸۹'
const arNums = '٠١٢٣٤٥٦٧٨٩'

export function normalizeNumbers(textContainingNumber) {
    if (!textContainingNumber) return textContainingNumber

    for (let i = 0; i < 10; i++) {
        const replaceFaToEn = new RegExp(faNums[i], 'g')
        const replaceArToEn = new RegExp(arNums[i], 'g')
        textContainingNumber = textContainingNumber.toString().replace(replaceFaToEn, i).replace(replaceArToEn, i)
    }

    return textContainingNumber
}

export function persifyNumbers(textContainingNumber) {
    if (!textContainingNumber) return textContainingNumber

    for (let i = 0; i < 10; i++) {
        const replaceArToFa = new RegExp(arNums[i], 'g')
        const replaceEnToFa = new RegExp(i, 'g')
        textContainingNumber = textContainingNumber.toString().replace(replaceArToFa, faNums[i]).replace(replaceEnToFa, faNums[i])
    }

    return textContainingNumber
}

export const num_e2p = s => s?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
export const num_e2a = s => s?.replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d])

export const num_p2e = s => s?.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
export const num_a2e = s => s?.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))

export const num_p2a = s => s?.replace(/[۰-۹]/g, d => '٠١٢٣٤٥٦٧٨٩'['۰۱۲۳۴۵۶۷۸۹'.indexOf(d)])
export const num_a2p = s => s?.replace(/[٠-٩]/g, d => '۰۱۲۳۴۵۶۷۸۹'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)])